<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-04 10:31:32
 * @Description: 账号激活 激活成功
-->
<template>
	<div>
		<div class="image">
			<img src="@/assets/images/forget/success_icon.png" alt="" />
		</div>
		<div class="desc">
			<div>
				<span>{{ $t("login.activate.success") }}</span
				><a @click="handleSuccess">{{ $t("login.activate.go") }}</a>
			</div>
			<p class="tips">{{ $t("login.activate.go_auto") }}{{ count }}s</p>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			count: 5,
		};
	},
	created() {
		// 移除 localStorage
		localStorage.removeItem("ACTIVATE_INFO");

		// 开启倒计时
		const timer = setInterval(() => {
			if (this.count >= 1) {
				this.count--;
			} else {
				clearInterval(timer);
				this.handleSuccess();
			}
		}, 1000);
	},
	methods: {
		handleSuccess() {
			this.$emit("success");
		},
	},
};
</script>

<style scoped lang="less">
.image {
	text-align: center;
}
.desc {
	text-align: center;
	margin-top: 20px;
	color: #000;
	.tips {
		color: #999;
		margin-top: 19px;
		font-size: 14px;
	}
}
</style>
